/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';
import {
  SET_INSTITUTIONS,
  FETCH_ENROLLED_INSTITUTIONS_SUCCESS,
} from './actions';
import {
  UPDATE_ENROLLED_CLASS_DATA,
  LOGOUT_SUCCESS,
  UPDATE_SIMPLE_ENROLLED_CLASS_DATA,
} from '../Auth/actions';
import {
  INSTITUTION_SET_WHITE_LABEL_LOGO_URL_SUCCESS,
  INSTITUTION_UPDATE_TEACH_SOMETHING_VISIBILITY_SUCCESS,
} from '../InstitutionAdmin/actions';
import { SEARCH_INSTITUTIONS_UPDATE } from '../Searches/actions';
import { QUALIFICATION_ENROLMENT_SUCCESS } from '../Portal/actions';
import { COURSE_NAVIGATION_DATA_SET } from '../CourseNavigationInfo/actions';
import {
  WASABI_SEARCH_INSTITUTIONS_SUCCESS,
  WASABI_FETCH_INSTITUTION_SUCCESS,
} from '../Wasabi/institutions/actions';
import { WASABI_FETCH_USER_INSTITUTIONS_SUCCESS } from '../Wasabi/users/actions';
import { FETCH_PARTNERS_LISTING_PAGE_DATA_SUCCESS } from '../../web/containers/PartnersListingPage/store';
import { FETCH_HOME_PAGE_DATA_SUCCESS } from '../../web/containers/HomePage/store';

const initialState = Immutable.Map();

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function Institutions(state = initialState, action = {}) {
  switch (action.type) {
    case WASABI_SEARCH_INSTITUTIONS_SUCCESS:
    case UPDATE_ENROLLED_CLASS_DATA:
    case COURSE_NAVIGATION_DATA_SET:
    case SET_INSTITUTIONS:
    case UPDATE_SIMPLE_ENROLLED_CLASS_DATA:
    case FETCH_ENROLLED_INSTITUTIONS_SUCCESS: {
      const { institutions } = action;
      let newState = state;
      for (const institution of institutions) {
        newState = newState.mergeIn(
          [institution.path],
          Immutable.fromJS(institution)
        );
      }
      return newState;
    }
    case SEARCH_INSTITUTIONS_UPDATE: {
      const { institutions } = action;
      const results = Immutable.fromJS(institutions).get('results');
      return results.reduce(
        (newState, item) => newState.set(item.get('path'), item),
        state
      );
    }
    case QUALIFICATION_ENROLMENT_SUCCESS: {
      const { institution } = action;
      if (!state.has(institution.path)) {
        return state.mergeIn([institution.path], Immutable.fromJS(institution));
      }
      return state;
    }
    case WASABI_FETCH_INSTITUTION_SUCCESS:
    case INSTITUTION_UPDATE_TEACH_SOMETHING_VISIBILITY_SUCCESS:
    case INSTITUTION_SET_WHITE_LABEL_LOGO_URL_SUCCESS: {
      const { institution } = action;
      return state.mergeIn([institution.path], Immutable.fromJS(institution));
    }
    case WASABI_FETCH_USER_INSTITUTIONS_SUCCESS: {
      const { institutions } = action;
      const results = Immutable.fromJS(institutions);
      return results.reduce(
        (newState, item) => newState.set(item.get('path'), item),
        state
      );
    }
    case FETCH_PARTNERS_LISTING_PAGE_DATA_SUCCESS: {
      const { localPartners, globalPartners } = action;
      let newState = state;
      for (const institution of [...localPartners, ...globalPartners]) {
        newState = newState.mergeIn(
          [institution.path],
          Immutable.fromJS(institution)
        );
      }
      return newState;
    }
    case FETCH_HOME_PAGE_DATA_SUCCESS: {
      const { featuredPartners } = action;
      let newState = state;
      for (const institution of featuredPartners) {
        newState = newState.mergeIn(
          [institution.path],
          Immutable.fromJS(institution)
        );
      }
      return newState;
    }
    case LOGOUT_SUCCESS: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}
